import { apiGet } from './http-client';

/** Уведомление А.3 для шага оплаты (Ф8, ТЗ 5.14 п.4). */
export type PDTransferNotice = {
  text: string;
  processors_hash: string;
  agreement_id: number | null;
  agreement_version: number;
  body_sha256?: string;
};

/**
 * GET `/api/v1/auth/me/pd-transfer-notice` — текст уведомления о передаче данных
 * для оплаты и кассового чека со списком получателей по филиалу слота.
 */
export function fetchPDTransferNotice(
  accessToken: string,
  organizationId: number | null,
  slotId: number
): Promise<PDTransferNotice> {
  return apiGet<PDTransferNotice>(
    '/api/v1/auth/me/pd-transfer-notice',
    { slot_id: slotId, organization_id: organizationId ?? undefined },
    { accessToken }
  );
}
